<template>
    <section class="container">
        <Swiper :swiper-option="swiperOption" />
        <div class="container-list">
            <div class="banner-reward flex a-center space-between">
                <span>拉勾教育学习计划在线领取</span>
                <button
                    class="flex btn a-center j-center hover-scale"
                    @click="gotoJump('立即申请')"
                >
                    <span class="btn-text">立即申请</span>
                    <span class="triangle" />
                </button>
            </div>
            <!-- <div class="section-top">
                <img src="https://s21.lgstatic.com/growth/activity/20210322/1616407731662.png">
            </div>
            <div class="section-btn">
                <img src="https://s21.lgstatic.com/growth/activity/20210322/1616406179206.png" @click="toApply()">
            </div> -->
            <section class="item dil">
                <div class="item-title">
                    拉勾调研显示  93%的前端工程师都面临此困境
                </div>
                <div class="item-container">
                    <div class="dil-i">
                        <div class="dil-i-h">
                            技术基础薄弱
                        </div>
                        <div class="dil-i-c">
                            只懂应用，不懂底层原理，知其然并不知其所以然，一旦遇到复杂问题就无从下手
                        </div>
                    </div>
                    <div class="dil-i">
                        <div class="dil-i-h">
                            自我提升困难
                        </div>
                        <div class="dil-i-c">
                            日常无法建立整体的知识体系，缺少系统化的学习和提升，短期无法提高
                        </div>
                    </div>
                    <div class="dil-i">
                        <div class="dil-i-h">
                            项目经验单一
                        </div>
                        <div class="dil-i-c">
                            长期从事重复工作，对高阶技能等缺乏实操经验，职业发展受到限制
                        </div>
                    </div>
                    <div class="dil-i">
                        <div class="dil-i-h">
                            进大厂无通道
                        </div>
                        <div class="dil-i-c">
                            现有的能力和经验不足以受到大厂的青睐，也没有猎头内推到大厂
                        </div>
                    </div>
                </div>
            </section>
            <section class="item rep">
                <div class="item-title">
                    饱受重复性工作的煎熬  拉勾助你摆脱困境
                </div>
                <div class="item-sub-t white">
                    拉勾5大优势，一站式解决前端进阶难题
                </div>
                <div class="rep-ads flex">
                    <div class="rep-ads-i">
                        <img
                            class="rep-ads-g"
                            src="../assets/img/ad-1.png"
                            alt=""
                        >
                        <div class="rep-ads-t">
                            主流前端技术知识全覆盖
                        </div>
                        <div class="rep-ads-s">
                            覆盖200+主流技术点，提高晋升阿里P7的完整路径，体系化夯实技术实力
                        </div>
                    </div>
                    <div class="rep-ads-i">
                        <img
                            class="rep-ads-g"
                            src="../assets/img/ad-2.png"
                            alt=""
                        >
                        <div class="rep-ads-t">
                            20+完整实战项目剖析
                        </div>
                        <div class="rep-ads-s">
                            100%还原多个公司的真前端项目，快速积累web、小程序、APP等泛客户端领域实战经验
                        </div>
                    </div>
                    <div class="rep-ads-i">
                        <img
                            class="rep-ads-g"
                            src="../assets/img/ad-3.png"
                            alt=""
                        >
                        <div class="rep-ads-t">
                            PB级企业大数据中台落地实践
                        </div>
                        <div class="rep-ads-s">
                            夯实语言底层基础，8大阶段逐步打造前端核心竞争力
                        </div>
                    </div>
                    <div class="rep-ads-i">
                        <img
                            class="rep-ads-g"
                            src="../assets/img/ad-4.png"
                            alt=""
                        >
                        <div class="rep-ads-t">
                            解决方案式教学
                        </div>
                        <div class="rep-ads-s">
                            提供20+商业级前端技术解决方案，轻松应对更多更难的业务问题，学来即用
                        </div>
                    </div>
                    <div class="rep-ads-i">
                        <img
                            class="rep-ads-g"
                            src="../assets/img/ad-5.png"
                            alt=""
                        >
                        <div class="rep-ads-t">
                            面试模拟+大厂内推
                        </div>
                        <div class="rep-ads-s">
                            直击面试重难点，优秀学员可享每月大厂内推机会，升职加薪不是梦
                        </div>
                    </div>
                </div>
                <button
                    class="sec-btn rep-btn hover-scale"
                    @click="toApply"
                >
                    优势疑问解答
                </button>
            </section>
            <section class="item skill">
                <div class="item-title">
                    课程设计对标阿里P7前端开发技能
                </div>
                <img
                    class="skill-i"
                    src="../assets/img/skill-i.png"
                    alt=""
                >
                <div
                    class="sec-btn rep-btn hover-scale"
                    @click="toApply"
                >
                    前端深度在线答疑
                </div>
            </section>
            <section class="item comp">
                <div class="item-title">
                    课程设计对标阿里P7前端开发技能
                </div>
                <div class="item-sub-t gray">
                    深入实战项目，180天扎实掌握web硬核技能
                </div>
                <div class="item-container flex">
                    <div
                        v-for="(item, index) in stageList"
                        :key="index + item.title"
                        class="i-c-l"
                        @mouseenter.stop="e => handleMouseEnter(e, index)"
                        @mouseleave.stop="handleMouseLeave"
                    >
                        <div class="i-c-l-t">
                            {{ item.desc }}
                        </div>
                        <div class="i-c-l-c">
                            <div
                                v-for="(stage, staIndex) in item.detail"
                                :key="staIndex"
                                class="i-c-l-a gray"
                            >
                                {{ stage.title }}
                            </div>
                        </div>
                        <span class="i-c-l-f">Part {{ index + 1 }}</span>
                    </div>
                    <CourseSection
                        ref="section"
                        :stage-list="stageList"
                    />
                </div>
                <button
                    class="sec-btn hover-scale"
                    @click="toApply"
                >
                    在线学习
                </button>
            </section>
            <section class="item edu">
                <div class="item-title">
                    项目驱动式教学培养实战型前端人才
                </div>
                <div class="item-container">
                    <div
                        class="t-list"
                    >
                        <span
                            :class="{'t-l-i': true, 't-l-j': curEdu === 0}"
                            @mouseenter.stop="() => handleListMouseEnter(0)"
                        >项目一</span>
                        <span
                            :class="{'t-l-i': true, 't-l-j': curEdu === 1}"
                            @mouseenter.stop="() => handleListMouseEnter(1)"
                        >项目二</span>
                        <span
                            :class="{'t-l-i': true, 't-l-j': curEdu === 2}"
                            @mouseenter.stop="() => handleListMouseEnter(2)"
                        >项目三</span>
                    </div>
                    <img
                        v-show="curEdu === 0"
                        class="img-l-i"
                        src="../assets/img/list-1.png"
                        alt=""
                    >
                    <img
                        v-show="curEdu === 1"
                        class="img-l-i"
                        src="../assets/img/list-2.png"
                        alt=""
                    >
                    <img
                        v-show="curEdu === 2"
                        class="img-l-i"
                        src="../assets/img/list-3.png"
                        alt=""
                    >
                </div>
                <button
                    class="sec-btn hover-scale"
                    @click="toApply"
                >
                    点击进入了解更多
                </button>
            </section>
            <section class="item diff">
                <div class="item-title white">
                    加入拉勾教育，轻松应对各种技术难题
                </div>
                <div class="item-sub-t white">
                    要做的工作不只是动效和切图
                </div>
                <div class="list-items flex space-between">
                    <img
                        class="img-item"
                        src="../assets/img/scheme-1.png"
                        alt=""
                    >
                    <img
                        class="img-item"
                        src="../assets/img/scheme-2.png"
                        alt=""
                    >
                </div>
                <button
                    class="sec-btn hover-scale"
                    @click="toApply"
                >
                    全套解决方案领取
                </button>
            </section>
            <section class="item ser">
                <div class="item-title">
                    拉勾独家内推服务  务实求职每一步
                </div>
                <div class="item-sub-t gray">
                    优秀学员可享每月内推
                </div>
                <div class="list-items">
                    <div
                        v-for="(item, index) in serviceList"
                        :key="index"
                        class="list-i"
                    >
                        <span class="label">{{ item.title }}</span>
                        {{ item.des }}
                        <div class="item-i" />
                    </div>
                </div>
                <button
                    class="sec-btn hover-scale"
                    @click="toApply"
                >
                    立即咨询
                </button>
            </section>
            <section class="item way">
                <div class="item-title">
                    8大复合场景学习方式   让学习变得轻松
                </div>
                <div class="item-sub-t gray">
                    复合场景学习方式  全方位辅助学习
                </div>
                <div class="list-items flex">
                    <div
                        v-for="(item, index) in studyList"
                        :key="index"
                        class="list-i flex a-center j-center"
                    >
                        <span class="label">{{ item.title }}</span>
                        <span class="gray">{{ item.des }}</span>
                    </div>
                </div>
            </section>
            <section class="item agg">
                <div class="item-title">
                    签订保障就业协议
                </div>
                <div class="item-sub-t gray">
                    拉勾求职绿色通道，直通一线互联网公司面试官
                </div>
                <img
                    class="agree-i"
                    src="../assets/img/agree.png"
                >
                <div class="agree-c flex j-center a-center">
                    <span class="agree-c-i gray">支持信用卡分期</span>
                    <span class="agree-c-j">0手续费 0利息</span>
                </div>
                <div class="agree-k gray">
                    轻松入学 帮你减轻负担
                </div>
                <button
                    class="sec-btn hover-scale"
                    @click="gotoJump('获取企业内推名额')"
                >
                    获取企业内推名额
                </button>
            </section>
        </div>
        <footer class="footer flex flex-center">
            <span>
                详细【学习计划】和专业老师【1V1求职指导】
            </span>
            <button
                class="flex btn flex-center hover-scale"
                @click="gotoJump('免费获取')"
            >
                <span class="btn-text">免费获取</span>
                <span class="triangle" />
            </button>
        </footer>
        <!-- 侧边导航栏 -->
        <LaunchNav :active-tab="2" />
    </section>
</template>

<script>
    import Swiper from '../../../components/Swiper/Index';
    import CourseSection from '../../../common/BigCourseSection/Index';
    import { handleJumpUrl } from '../../../uitl/getParam.js';
    import LaunchNav from '../../../components/LaunchNav/index';
    import axios from '../../../service/index';

    export default {
        name: 'Index',
        components: {
            Swiper,
            CourseSection,
            LaunchNav
        },
        data() {
            return {
                swiperOption: {
                    assetsList: [
                        {
                            image: require('../assets/img/banner01.png'),
                            href: ' '
                        }, {
                            image: require('../assets/img/banner02.png'),
                            href: ' '
                        },
                        // {
                        //     image: 'https://s21.lgstatic.com/growth/activity/20210322/1616405724164.png',
                        //     href: ' '
                        // }
                    ]
                },
                stageList: [],
                curEdu: 0,
                serviceList: [
                    {
                        title: '真题解忧', des: 'BAT等一线大厂面试真题解析，务实面试基础',
                    },
                    {
                        title: '简历优化', des: '扬长避短，让HR三秒记住你，提升简历通过率'
                    },
                    {
                        title: '面试模拟', des: '真实的面试流程模拟，查缺补漏，一举拿下面试'
                    },
                    {
                        title: '大厂内推', des: '70万+企业资源，简历直通TL，让offer不再难拿'
                    }

                ],
                studyList: [
                    { title: '线上学习', des: '突破时间、空间限制' },
                    { title: '实践拓展', des: '大咖直播面对面' },
                    { title: '陪伴学习', des: '班主任全程伴读' },
                    { title: '源码开放', des: '项目代码免费送' },
                    { title: '独家资料', des: '资料随堂提供' },
                    { title: '定期测评', des: '专项突击式训练' },
                    { title: '模拟面试', des: '直击面试重点' },
                    { title: '大厂内推', des: '每月优秀学员直推大厂' },
                ],
            };
        },
        created() {
            axios.get('/kw/adam/ad/detail/fed').then(res => {
                this.stageList = res.data?.data?.stageList || [];
            }).catch(error => {
                console.log(error);
            });
        },
        mounted() {

        },
        methods: {
            handleMouseEnter(e, index) {
                this.$refs.section.handleMouseEnter(e, index);
            },
            handleMouseLeave() {
                this.$refs.section.handleMouseLeave();
            },
            handleListMouseEnter(index) {
                this.curEdu = index;
            },
            gotoJump(name) {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': '1pxi',
                    'button_name': name
                });
                handleJumpUrl(`75022597f6fb4408ae50310a1a551964`);
            },
            toApply() {
                window.open('https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2');
            },
        }
    };
</script>

<style scoped lang="less">
    .white {
        color: white;
    }
    .gray {
        color: #666666;
    }
    .container {
        background: rgba(246,246,246,1);
        box-sizing: border-box;
    }
    /deep/.swiper-container {
        width: 100%;
        img {
            width: 100%;
        }
    }
    .container-list {
        position: relative;
        &::before {
            content: '';
            height: 525PX;
            top: -525PX;
            left: 0;
            right: 0;
            position: absolute;
            z-index: 1;
        }
    }
    .banner-reward {
        position: absolute;
        width: 1200PX;
        height: 150PX;
        left: 50%;
        transform: translateX(-50%);
        top: -75PX;
        z-index: 1;
        background:linear-gradient(90deg,rgba(249,230,212,1) 0%,rgba(241,209,169,1) 100%);
        border-radius:20PX;
        font-size: 48PX;
        padding: 0 110PX;
        box-sizing: border-box;
        .triangle {
            width: 0;
            height: 0;
            content: '';
            border: 10PX solid;
            border-color: transparent transparent transparent #3B1907;
            margin-left: 10PX;
        }
        .btn {
            width: 230PX;
            height: 70PX;
            background: white;
            border-radius: 33PX;
        }
        .btn-text {
            font-size: 30PX;
            font-weight: bold;
        }
    }
    .hover-scale{
        transform: scale(1);
        transition: all 0.1s ease-in;
        &:hover {
            transform: scale(1.1);
        }
    }
    .item {
        box-sizing: border-box;
        color: #333333;
        &:nth-of-type(odd) {
            padding-top: 120PX;
        }
        &:nth-of-type(even) {
            padding-top: 60PX;
        }

        &:nth-of-type(1) {
            &::before {
                display: block;
                content: '';
                height: 69PX;
            }
            .item-title {
                background-image: url("../assets/img/item-title-1.png");
            }
        }
        &:nth-of-type(2) {
            .item-title {
                color: #ffffff;
                background-image: url("../assets/img/item-title-2.png");
            }
        }
        &:nth-of-type(3) {
            .item-title {
                background-image: url("../assets/img/item-title-3.png");
            }
        }
        &:nth-of-type(4) {
            .item-title {
                background-image: url("../assets/img/item-title-4.png");
            }
        }
        &:nth-of-type(5) {
            .item-title {
                background-image: url("../assets/img/item-title-5.png");
            }
        }
        &:nth-of-type(6) {
            .item-title {
                line-height: 107PX;
                background-image: url("../assets/img/item-title-6.png");
            }
        }
        &:nth-of-type(7) {
            .item-title {
                line-height: 107PX;
                background-image: url("../assets/img/item-title-7.png");
            }
        }
        &:nth-of-type(8) {
            .item-title {
                line-height: 107PX;
                background-image: url("../assets/img/item-title-8.png");
            }
        }
        &:nth-of-type(9) {
            .item-title {
                background-image: url("../assets/img/item-title-9.png");
            }
        }
        .item-title {
            font-weight: bold;
            font-size: 48PX;
            background-position-x: center;
            background-repeat: no-repeat;
            text-align: center;
        }
        .item-sub-t {
            font-size: 28PX;
            text-align: center;
        }
    }
    .sec-btn {
        width:424PX;
        height:90PX;
        line-height: 90PX;
        text-align: center;
        background:linear-gradient(90deg,rgba(249,230,212,1) 0%,rgba(241,209,169,1) 100%);
        border-radius:10PX;
        margin: 0 auto;
        font-size:30PX;
        color: #3B1907;
        cursor: pointer;
        display: block;
        border: none;
    }
    .dil {
        padding: 120PX 0 137PX;
        .dil-i {
            position: relative;
            height: 130PX;
            width: 848PX;
            background: #fff;
            display: flex;
            align-items: center;
            border-radius: 0 20PX 20PX 0;
            padding-right: 46PX;
            box-sizing: border-box;
            border-left: 46PX solid white;
            margin: 40PX auto 0;
            transform: translateX(86PX);
            &:first-of-type {
                margin-top: 60PX;
            }
        }
        .dil-i-h {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 192PX;
            background:linear-gradient(90deg,rgba(249,230,212,1) 0%,rgba(241,209,169,1) 100%);
            border-radius:97PX 10PX 10PX 10PX;
            font-size:32PX;
            font-weight:500;
            color: #3B1907;
            left: -216PX;
            padding: 20PX 30PX;
            box-sizing: border-box;
            text-align: center;
        }
        .dil-i-c {
            font-size:26PX;
            color: #666666;
        }
    }
    .rep {
        background: url("../assets/img/section-bg-2.png") no-repeat;
        background-size: 100% 100%;
        height:1065PX;
        text-align: center;
        .rep-ads {
            width: 1200PX;
            margin: 60PX auto 0;
            flex-wrap: wrap;
            justify-content: center;
        }
        .rep-ads-i {
            width:380PX;
            height:232PX;
            box-sizing: border-box;
            padding: 50PX 14PX 0;
            background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(248,242,231,1) 99%);
            border-radius:10PX;
            position: relative;
            margin: 10PX;
            &:hover {
                transform: scale(1.05);
            }
            &:nth-of-type(5) {
                margin-left: 35PX;
                margin-top: 80PX;
            }
            &:nth-of-type(4) {
                margin-top: 80PX;
            }
        }
        .rep-ads-g {
            width: 80PX;
            height: 80PX;
            position: absolute;
            top: -40PX;
            left: 50%;
            transform: translateX(-50%);
        }
        .rep-ads-t {
            font-size:26PX;
            font-weight:500;
            color: #AA5421;
        }
        .rep-ads-s {
            color: #666666;
            font-size: 22PX;
            margin-top: 10PX;
        }
        .rep-btn {
            margin-top: 50PX;
        }
    }
    .skill {
        padding-bottom: 120PX;
        .skill-i {
            margin: auto;
            display: block;
        }
    }
    .comp {
        background: url("../assets/img/section-bg-4.png") no-repeat;
        background-size: 100% 100%;
        padding-bottom: 60PX;
        .item-container {
            margin: 20PX auto 0;
            width: 1300PX;
            flex-wrap: wrap;
            position: relative;
        }
        .i-c-l {
            width:285PX;
            height:360PX;
            background:rgba(255,255,255,1);
            border-radius:10px;
            margin: 40PX 10PX 0;
            position: relative;
        }
        .i-c-l-t {
            height:90PX;
            line-height: 90PX;
            background:linear-gradient(90deg,rgba(249,230,212,1) 0%,rgba(241,209,169,1) 100%);
            border-radius:10PX;
            color: #3B1907;
            font-size: 24PX;
            text-align: center;
        }
        .i-c-l-c {
            font-size: 22PX;
            padding: 20PX 0 0 30PX;
            position: relative;
        }
        .i-c-l-a {
            position: relative;
            &::before {
                width: 7PX;
                height: 7PX;
                content: '';
                display: inline-block;
                border-radius: 50%;
                background: #EFCCA0;
                position: absolute;
                top: 14PX;
                left: -19PX;
            }
        }
        .i-c-l-f {
            color: #F7E1C9;
            font-size: 36PX;
            position: absolute;
            right: 20PX;
            bottom: 0;
        }
        .sec-btn {
            margin-top: 80PX;
        }
    }
    .edu {
        padding-bottom: 120PX;
        .item-container {
            width: 1200PX;
            margin: 67PX auto 0;
        }
        .t-list {
            position: relative;
            height: 80PX;
        }
        .t-l-i {
            position: absolute;
            width: 321PX;
            height: 80PX;
            background: url("../assets/img/list-t.png") no-repeat;
            background-size: 100%;
            bottom: 0;
            font-size: 36PX;
            color: #3B1907;
            line-height: 80PX;
            text-align: center;
            &:nth-of-type(2) {
                left: 260PX;
                z-index: 2;
            }
            &:nth-of-type(3) {
                left: 515PX;
            }
        }
        .t-l-j {
            /*height: 88PX;*/
            background: url("../assets/img/list-t-h.png");
            z-index: 3;
            /*line-height: 88PX;*/
        }
        .img-l-i {
            width: 1200PX;
            margin: 0 auto;
        }
        .sec-btn {
            margin-top: 40PX;
        }
    }
    .diff {
        background: url("../assets/img/section-bg-5.png") no-repeat;
        background-size: 100% 100%;
        padding-bottom: 60PX;
        .list-items {
            width: 1200PX;
            margin: 80PX auto 60PX;
        }
    }
    .ser {
        padding-bottom: 120PX;
        .list-items {
            width:906PX;
            margin: 60PX auto 0;
        }
        .list-i {
            position: relative;
            width:905PX;
            height:80PX;
            line-height: 80PX;
            background:rgba(255,255,255,1);
            margin-top: 46PX;
            font-size:26PX;
            border-radius:10PX;
            padding-left: 300PX;
            box-sizing: border-box;
            &:nth-of-type(1) .item-i {
                background-image: url("../assets/img/label-1.png");
            }
            &:nth-of-type(2) .item-i {
                background-image: url("../assets/img/label-2.png");
            }
            &:nth-of-type(3) .item-i {
                background-image: url("../assets/img/label-3.png");
            }
            &:nth-of-type(4) .item-i {
                background-image: url("../assets/img/label-4.png");
            }
            .label {
                width:253PX;
                height:80PX;
                background:linear-gradient(90deg,rgba(249,230,212,1) 0%,rgba(241,209,169,1) 100%);
                border-radius:10PX;
                color: #333333;
                position: absolute;
                font-size: 32PX;
                left: 0;
                top: 0;
                text-align: center;
            }
            .item-i {
                width: 83PX;
                height: 64PX;
                position: absolute;
                right: 19PX;
                top: -45PX;
                background-size: 100%;
                background-repeat: no-repeat;
            }
        }
        .sec-btn {
            margin-top: 60PX;
        }
    }
    .way {
        background: url("../assets/img/section-bg-6.png") no-repeat;
        background-size: 100% 100%;
        padding-bottom: 100PX;
        .list-items {
            width: 1226PX;
            margin: -24PX auto 0;
            flex-wrap: wrap;
        }
        .list-i {
            width: 280PX;
            height: 120PX;
            background:rgba(255,255,255,1);
            border-radius:10px;
            margin: 84PX 13PX 0;
            position: relative;
            font-size: 23PX;
            &::after {
                content: '';
                width:262PX;
                height:101PX;
                border-radius:10px;
                border:1px solid rgba(244,209,174,1);
                position: absolute;
            }
        }
        .label {
            position: absolute;
            width:180PX;
            height:48PX;
            background:linear-gradient(180deg,rgba(255,241,225,1) 0%,rgba(244,209,172,1) 100%);
            border-radius:10PX 10PX 0 0;
            top: -24PX;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            line-height: 48PX;
            color: #AA5421;
            font-size: 24PX;
            z-index: 1;
        }
    }
    .agg {
        border-bottom: 268PX solid #F6F6F6;
        .agree-i {
            width: 990PX;
            margin: 60PX auto 0;
            display: block;
        }
        .agree-c {
            font-size: 36PX;
            margin-top: 66PX;
        }
        .agree-c-j {
            margin-left: 58PX;
            color: #AA5421;
        }
        .agree-k {
            font-size: 28PX;
            margin-top: 27PX;
            text-align: center;
        }
        .sec-btn {
            margin-top: 60PX;
        }
    }
    .footer {
        height:100PX;
        background: rgba(241,209,169,1);
        background:linear-gradient(90deg,rgba(249,230,212,1) 0%,rgba(241,209,169,1) 100%);
        font-size: 34PX;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 5;
        .triangle {
            width: 0;
            height: 0;
            content: '';
            border: 10PX solid;
            border-color: transparent transparent transparent #3B1907;
            margin-left: 10PX;
        }
        .btn {
            width: 230PX;
            height: 70PX;
            background: white;
            border-radius: 40PX;
            margin-left: 37PX;
        }
        .btn-text {
            font-size: 30PX;
            font-weight: bold;
        }
    }
    .section-top {
        width: 100%;
        min-width: 1200PX;
        overflow: hidden;
        img {
            width: 896PX;
            margin: 130PX auto 50PX;
            display: block;
        }
    }
    .section-btn {
        width: 100%;
        min-width: 1200PX;
        img {
            cursor: pointer;
            display: block;
            margin: 20PX auto;
            width: 380PX;
            height: 80PX;
        }
    }
</style>
